/**
 * api.js — Реэкспорт из модульной директории ./api/index.js
 * Обеспечивает обратную совместимость для всех существующих импортов.
 */
export * from './api/index'
